import { ApiError } from '@/lib/api-error';

export const MAX_QUERY_RETRIES = 3;

/**
 * The app-wide React Query retry policy. Only a transient failure is retried: a typed 4xx
 * (auth, permission, validation, not-found, a feature that is off) answers the same way every
 * time, so retrying it only holds the page in its loading state through the backoff (#6780).
 */
export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  if (error instanceof ApiError) {
    return error.status >= 500 && failureCount < MAX_QUERY_RETRIES;
  }
  if (error instanceof Error && error.name === 'UnauthorizedError') {
    return false;
  }
  // Fallback for endpoints not yet migrated to assertOk: substring-match the
  // legacy hand-written messages (audit finding 180 — being phased out).
  if (error instanceof Error) {
    const msg = error.message.toLowerCase();
    if (msg.includes('unauthorized') || msg.includes('forbidden') || msg.includes('not permitted') || msg.includes('access denied')) {
      return false;
    }
  }
  return failureCount < MAX_QUERY_RETRIES;
}
